import { useState } from "react";
import styled from "styled-components";
import Navigation from "./Navigation";
import Bi from "./Bi";
import DefaultContainer from "./DefaultContainer";

const Container = styled.header`
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: fixed;
  display: flex;
  justify-content: center;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;

  @media (max-width: 768px) {
    height: 56px;
  }
`;

const Contents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;

  @media (max-width: 768px) {
    height: 56px;
  }
`;

const HamburgerButton = styled.button<{ $isOpen: boolean }>`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 110;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }

  span {
    display: block;
    width: 22px;
    height: 2px;
    background-color: #343a40;
    border-radius: 2px;
    transition: all 0.3s ease;

    &:nth-child(1) {
      transform: ${({ $isOpen }) =>
        $isOpen ? "rotate(45deg) translate(5px, 5px)" : "none"};
    }
    &:nth-child(2) {
      opacity: ${({ $isOpen }) => ($isOpen ? "0" : "1")};
    }
    &:nth-child(3) {
      transform: ${({ $isOpen }) =>
        $isOpen ? "rotate(-45deg) translate(5px, -5px)" : "none"};
    }
  }
`;

const DesktopNav = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileOverlay = styled.div<{ $isOpen: boolean }>`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: ${({ $isOpen }) => ($isOpen ? "1" : "0")};
    visibility: ${({ $isOpen }) => ($isOpen ? "visible" : "hidden")};
    transition: all 0.3s ease;
    z-index: 99;
  }
`;

const MobileNav = styled.div<{ $isOpen: boolean }>`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    width: 260px;
    height: 100vh;
    background: white;
    padding: 80px 30px 30px;
    transform: ${({ $isOpen }) =>
      $isOpen ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.3s ease;
    z-index: 100;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  }
`;

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <Container>
        <DefaultContainer>
          <Contents>
            <Bi />
            <DesktopNav>
              <Navigation />
            </DesktopNav>
            <HamburgerButton
              $isOpen={isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="메뉴"
            >
              <span />
              <span />
              <span />
            </HamburgerButton>
          </Contents>
        </DefaultContainer>
      </Container>
      <MobileOverlay
        $isOpen={isMobileMenuOpen}
        onClick={closeMobileMenu}
      />
      <MobileNav $isOpen={isMobileMenuOpen}>
        <Navigation mobile onNavigate={closeMobileMenu} />
      </MobileNav>
    </>
  );
};

export default Header;
